import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {OrganizationModel} from './organization.model';
import {LocationModel} from './location.model';
import {ConfigModel} from './config.model';
import {TournamentCategoryModel} from './tournament-category.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'tournamentId',
  eventId: 'eventId',
  locationId: 'locationId',
  configId: 'configId',
  name: 'name',
  modality: 'modality',
  startDate: 'startDate',
  endDate: 'endDate',
  status: 'status',

  // @TODO: deprecated
  // event: 'event',
  organization: 'organization',
  location: 'location',
  config: 'config',
  tournamentsCategories: 'tournamentsCategories',
};

export class TournamentModel extends Model {
  eventId!: number;
  locationId!: number;
  name!: string;
  modality!: string;
  startDate!: Date;
  endDate!: Date;
  status!: string;

  // @TODO: deprecated
  // event?: EventModel;
  organization?: OrganizationModel;
  location?: LocationModel;
  config?: ConfigModel;
  tournamentsCategories!: TournamentCategoryModel[];

  static getInstance(data: Params): TournamentModel {
    const model = new TournamentModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (['startDate', 'endDate'].includes(prop)) {
        // Hace la correccion de la zona horaria del cliente
        const date = new Date(data[propsMapping[prop]]);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        (model as Params)[prop] = date;
      // @TODO: deprecated
      // } else if (prop === 'event') {
      //   (model as Params)[prop] = EventModel.getInstance(data[propsMapping[prop]]);
      } else if (prop === 'organization') {
        (model as Params)[prop] = OrganizationModel.getInstance(data[propsMapping[prop]]);
      } else if (prop === 'location') {
        (model as Params)[prop] = LocationModel.getInstance(data[propsMapping[prop]]);
      } else if (prop === 'config') {
        (model as Params)[prop] = ConfigModel.getInstance(data[propsMapping[prop]]);
      } else if (prop === 'tournamentsCategories') {
        if (Array.isArray(data[propsMapping[prop]])) {
          (model as Params)[prop] = data[propsMapping[prop]].map((item: Params): TournamentCategoryModel => {
            return TournamentCategoryModel.getInstance(item);
          });
        }
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    if (!Array.isArray(model.tournamentsCategories)) {
      model.tournamentsCategories = [];
    }

    return model;
  }
}
